(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-video-stories"] && !window.DesignMode) return;
  try {
    
class ShopifyStoryPlayer {
  constructor() {
    this.trigger = document.querySelector('[data-stories-trigger]');
    this.overlay = document.querySelector('[data-stories-overlay]');
    this.storiesContent = document.querySelector('[data-stories-content]');
    this.stories = Array.from(document.querySelectorAll('.shopify-story-item'));
    this.progressBars = Array.from(document.querySelectorAll('.shopify-progress-bar'));
    this.closeButtons = document.querySelectorAll('[data-close-stories]');
    this.previewVideo = document.querySelector('.shopify-preview-video');
    
    this.currentIndex = 0;
    this.isPlaying = false;
    this.progressTimeout = null;
    this.watchedStories = new Set();
    this.currentProgressAnimation = null;

    if (this.stories.length > 0) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
    this.setupVideos();
    this.setupPreviewVideo();
    this.setupTapAreas();
  }

  setupPreviewVideo() {
    if (this.previewVideo) {
      this.previewVideo.load();
      
      const playAttempt = this.previewVideo.play();
      
      if (playAttempt !== undefined) {
        playAttempt.catch(() => {
          const startPlayback = () => {
            this.previewVideo.play().catch(() => {});
            document.removeEventListener('touchstart', startPlayback);
            document.removeEventListener('click', startPlayback);
          };
          
          document.addEventListener('touchstart', startPlayback, { once: true });
          document.addEventListener('click', startPlayback, { once: true });
        });
      }
    }
  }

  setupVideos() {
    this.stories.forEach(story => {
      const video = story.querySelector('.shopify-story-video');
      if (video) {
        video.playsInline = true;
        video.addEventListener('ended', () => {
          this.completeCurrentStory();
          this.navigate('next');
        });
        video.addEventListener('error', () => this.navigate('next'));
      }
    });
  }

  setupTapAreas() {
    this.stories.forEach(story => {
      const tapPrev = story.querySelector('[data-tap="prev"]');
      const tapNext = story.querySelector('[data-tap="next"]');

      if (tapPrev) {
        tapPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          this.navigate('prev', true);
        });
      }

      if (tapNext) {
        tapNext.addEventListener('click', (e) => {
          e.stopPropagation();
          this.completeCurrentStory();
          this.navigate('next');
        });
      }
    });
  }

  bindEvents() {
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.openStories());
    }

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.closeStories());
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.closeStories();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!this.overlay?.classList.contains('active')) return;
      
      switch (e.key) {
        case 'ArrowLeft':
          this.navigate('prev', true);
          break;
        case 'ArrowRight':
          this.completeCurrentStory();
          this.navigate('next');
          break;
        case 'Escape':
          this.closeStories();
          break;
      }
    });
  }

  completeCurrentStory() {
    const currentProgressBar = this.progressBars[this.currentIndex];
    if (currentProgressBar) {
      const fill = currentProgressBar.querySelector('.shopify-progress-fill');
      if (fill) {
        if (this.currentProgressAnimation) {
          this.currentProgressAnimation.cancel();
        }
        fill.style.transition = 'none';
        fill.style.width = '100%';
      }
    }
    this.watchedStories.add(this.currentIndex);
  }

  resetProgressBar(index) {
    const progressBar = this.progressBars[index];
    if (progressBar) {
      const fill = progressBar.querySelector('.shopify-progress-fill');
      if (fill) {
        if (this.currentProgressAnimation) {
          this.currentProgressAnimation.cancel();
        }
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth;
      }
    }
  }

  openStories() {
    if (this.overlay) {
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.showStory(0);
    }
  }

  closeStories() {
    if (this.overlay) {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
      this.resetStories();
    }
  }

  resetStories() {
    this.isPlaying = false;
    clearTimeout(this.progressTimeout);
    
    if (this.currentProgressAnimation) {
      this.currentProgressAnimation.cancel();
    }
    
    this.stories.forEach(story => {
      story.classList.remove('active');
      const video = story.querySelector('.shopify-story-video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    this.progressBars.forEach((bar, index) => {
      const fill = bar.querySelector('.shopify-progress-fill');
      if (fill) {
        fill.style.transition = 'none';
        fill.style.width = this.watchedStories.has(index) ? '100%' : '0%';
      }
    });
  }

  showStory(index) {
    const previousStory = this.stories[this.currentIndex];
    if (previousStory) {
      previousStory.classList.remove('active');
      const previousVideo = previousStory.querySelector('.shopify-story-video');
      if (previousVideo) {
        previousVideo.pause();
      }
    }
    
    const story = this.stories[index];
    if (!story) return;

    story.classList.add('active');
    this.currentIndex = index;
    this.isPlaying = true;

    const video = story.querySelector('.shopify-story-video');
    if (!video) return;

    video.currentTime = 0;
    
    const progressFill = this.progressBars[index]?.querySelector('.shopify-progress-fill');
    if (progressFill && !this.watchedStories.has(index)) {
      if (this.currentProgressAnimation) {
        this.currentProgressAnimation.cancel();
      }

      progressFill.style.transition = 'none';
      progressFill.style.width = '0%';
      void progressFill.offsetWidth;

      this.currentProgressAnimation = progressFill.animate(
        [
          { width: '0%' },
          { width: '100%' }
        ],
        {
          duration: video.duration * 1000,
          easing: 'linear',
          fill: 'forwards'
        }
      );
    }

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        const duration = video.duration * 1000;
        this.progressTimeout = setTimeout(() => {
          this.completeCurrentStory();
          this.navigate('next');
        }, duration);
      }).catch(() => {
        this.navigate('next');
      });
    }
  }

  navigate(direction, resetProgress = false) {
    clearTimeout(this.progressTimeout);
    
    if (this.currentProgressAnimation) {
      this.currentProgressAnimation.cancel();
    }
    
    let nextIndex;
    if (direction === 'next') {
      nextIndex = this.currentIndex + 1;
      if (nextIndex >= this.stories.length) {
        this.closeStories();
        return;
      }
    } else {
      nextIndex = this.currentIndex - 1;
      if (nextIndex < 0) nextIndex = 0;
      
      if (resetProgress) {
        this.watchedStories.delete(nextIndex);
        this.resetProgressBar(nextIndex);
      }
    }

    this.showStory(nextIndex);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ShopifyStoryPlayer();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !window.DesignMode) return;
  try {
    
// Add intersection observer to pause animation when not in viewport
if (IntersectionObserver) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const track = entry.target.querySelector('.image-marquee__track');
      if (track) {
        track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.image-carousel__container').forEach(carousel => {
    observer.observe(carousel);
  });
}

// Preload images for smoother experience
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.image-slide-image');
  if ('connection' in navigator && (navigator.connection.saveData === false || navigator.connection.saveData === undefined)) {
    images.forEach(img => {
      if (img.dataset.src) {
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'preload';
        preloadLink.as = 'image';
        preloadLink.href = img.dataset.src;
        document.head.appendChild(preloadLink);
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
